import React from 'react';

const NAV_LINKS = [
  {
    heading: 'Product',
    links: [
      { label: 'How It Works', href: '#how-it-works', internal: true },
      { label: 'Features', href: '#features', internal: true },
      { label: 'Pricing', href: '#pricing', internal: true },
      { label: 'FAQ', href: null, action: 'faq' },
      { label: 'Try Demo', href: null, action: 'demo' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'About', href: '#about', internal: true },
      { label: 'Privacy Policy', href: null, action: 'privacy' },
      { label: 'Terms of Service', href: null, action: 'terms' },
    ],
  },
];

export default function SiteFooter({ onShowPrivacy, onShowTerms, onEnterApp, onShowFaq }) {
  const handleAction = (action) => {
    if (action === 'privacy' && onShowPrivacy) onShowPrivacy();
    if (action === 'terms' && onShowTerms) onShowTerms();
    if (action === 'demo' && onEnterApp) onEnterApp();
    if (action === 'faq' && onShowFaq) onShowFaq();
  };

  return (
    <footer style={{ backgroundColor: 'var(--brand-charcoal)' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-14 pb-8">

        {/* Top row */}
        <div className="grid sm:grid-cols-3 gap-10 mb-12">
          {/* Brand column */}
          <div>
            <img src="/new_icon+text_white.png" alt="CraftMyParty" className="h-12 w-auto mb-4" style={{ opacity: 0.9 }} />
            <p className="text-sm leading-relaxed" style={{ color: '#A8A29E' }}>
              AI-powered party planning — themes, shopping lists, and budgets in minutes.
            </p>
          </div>

          {/* Nav columns */}
          {NAV_LINKS.map(({ heading, links }) => (
            <div key={heading}>
              <p className="text-xs font-semibold uppercase tracking-widest mb-4" style={{ color: '#78716C' }}>
                {heading}
              </p>
              <ul className="space-y-2.5">
                {links.map(({ label, href, action, internal }) => (
                  <li key={label}>
                    {action ? (
                      <button
                        onClick={() => handleAction(action)}
                        className="text-sm transition-colors duration-150 text-left"
                        style={{ color: '#A8A29E' }}
                        onMouseEnter={(e) => (e.target.style.color = '#fff')}
                        onMouseLeave={(e) => (e.target.style.color = '#A8A29E')}
                      >
                        {label}
                      </button>
                    ) : (
                      <a
                        href={href}
                        className="text-sm transition-colors duration-150"
                        style={{ color: '#A8A29E' }}
                        onMouseEnter={(e) => (e.target.style.color = '#fff')}
                        onMouseLeave={(e) => (e.target.style.color = '#A8A29E')}
                      >
                        {label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="border-t" style={{ borderColor: '#292524' }} />

        {/* Bottom row */}
        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm" style={{ color: '#78716C' }}>
          <p>© {new Date().getFullYear()} CraftMyParty. All rights reserved.</p>
          <p>Made with ♥ for party hosts everywhere.</p>
        </div>
      </div>
    </footer>
  );
}
